import React from 'react';
import { TextField } from '../core-form-fields/BaseTextField';

interface PhoneFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export const PhoneField: React.FC<PhoneFieldProps> = ({ 
  value, 
  onChange, 
  required = false 
}) => {
  return (
    <TextField
      id="phone"
      label="Phone"
      type="tel"
      value={value}
      onChange={onChange}
      required={required}
      validation={{
        pattern: /^\+?[1-9]\d{1,14}$/,
        customValidation: (value) => {
          if (value && !value.match(/^\+?[1-9]\d{1,14}$/)) {
            return "Please enter a valid international phone number";
          }
          if (value && value.length < 7) {
            return "Phone number is too short";
          }
          if (value && value.length > 15) {
            return "Phone number is too long";
          }
          return undefined;
        }
      }}
      placeholder="Enter your phone number"
    />
  );
};